import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler, MAX_ANIMATION_TIMEOUT,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection
} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideClientHydration, withEventReplay} from '@angular/platform-browser';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {prefixInterceptorFactory} from '@xstudioz/interceptors/prefix-interceptor';
import {provideNgxStripe} from 'ngx-stripe';
import {DialogService} from 'primeng/dynamicdialog';
import {provideAnimations, provideNoopAnimations} from '@angular/platform-browser/animations';
import {providePrimeNG} from 'primeng/config';
import {definePreset} from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import {provideErrorTailorConfig} from '@ngneat/error-tailor';
import {Router} from '@angular/router';
import * as Sentry from "@sentry/angular";
import {MessageService} from 'primeng/api';

const MyPreset = definePreset(Aura, {});
export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
    provideNoopAnimations(),
    {provide: MAX_ANIMATION_TIMEOUT, useValue: 1000},
    provideHttpClient(withInterceptors([prefixInterceptorFactory('/api')])),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes), provideClientHydration(withEventReplay()),
    provideNgxStripe('pk_test_51S6EiMJJhIl9uEiNHDp4ZDInsNHo2T2WWwjn7CIS8NSNy6nupa4ZLHI8rAfKnRljKckfsdzGH0cpcoApFmLq6NGS00euF3FJMb'),
    DialogService, MessageService,
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.dark'
        }
      }
    }),
    provideErrorTailorConfig({
      errors: {
        useValue: {
          required: 'This field is required',
          email: 'Invalid email address',
          minlength: ({requiredLength, actualLength}) =>
            `Expect ${requiredLength} but got ${actualLength}`,
          invalidAddress: error => `Address isn't valid`
        }
      }
    })
  ]
};
